import React from 'react';
import { CnList } from "../../../cn-list";
import { CascaderListItem, } from './cascader-list-item';
export function CascaderList(props) {
    var options = props.options, value = props.value, onClick = props.onClick, loadData = props.loadData, multiple = props.multiple, handleSelect = props.handleSelect;
    return (React.createElement(CnList, { className: "cn-ui-m-cascader-list" }, options.map(function (item) { return (React.createElement(CascaderListItem, { key: item.value, data: item, onClick: onClick, loadData: loadData, value: value, multiple: multiple, handleSelect: handleSelect })); })));
}
